import React, { useEffect, useState } from "react";
import TableHeader from "../table/TableHeader";
import MainTableBody from "../table/MainTableBody";
import CustomTable from "../table/CustomTable";
import { LoadingTableSkeleton } from "../../utils/common";
import NoDataTable from "../table/NoDataTable";
import LogsTableRow from "./LogsTableRow";
import FilterDropdown from "../filter/FilterDropdown";
import { TablePagination } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

export const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  paddingLeft: 10,
  paddingRight: 10,
  paddingTop: 8,
  paddingBottom: 8,
};

export default function LogsTable({ reqState, object, setObject, handleFetch, handleFetchWithPage }) {
  const [rowsPerPage, setRowsPerPage] = useState(0);
  const [page, setPage] = React.useState(0);
  const navigate = useNavigate();
  const location = useLocation();


  useEffect(() => {
    if (reqState.response?.pageInfo) {
      setRowsPerPage(reqState.response.pageInfo.perPage);
      setPage(reqState.response.pageInfo.currentPage - 1); // Convert to 0-indexed for MUI
    }
  }, [reqState.response]);


  const updateQueryParams = (updatedParams) => {
    const searchParams = new URLSearchParams(location.search);

    // Update or remove query parameters based on `updatedParams`
    Object.keys(updatedParams).forEach((key) => {
      if (updatedParams[key] !== undefined && updatedParams[key] !== null) {
        searchParams.set(key, updatedParams[key]);
      } else {
        searchParams.delete(key);
      }
    });

    // Navigate with updated query parameters
    navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
  };

  const { isLoading, response } = reqState;

  const refetch = () => {
    // const q = { ...query, page: 1 };
    // if (!q.query) delete q.query;
    // navigate({
    //   pathname: window.location.pathname, // current path
    //   search: `?${new URLSearchParams(q).toString()}`, // query string
    // }, { replace: true });
    handleFetch()
  };


  const columns = [
    "Journey Id",
    "Application No",
    "Log Type",
    "Message",
    "Timestamp",
    "Metadata",
  ];

  useEffect(() => {
    if (response?.pageInfo) {
      setRowsPerPage(response?.pageInfo.perPage)
      setPage(response?.pageInfo?.currentPage - 1)
    }
  }, [response])


  const handleChangePage = (event, newPage) => {
    const updatedPage = newPage + 1; // Material-UI uses 0-based indexing
    updateQueryParams({ page: updatedPage });
    handleFetchWithPage(updatedPage); // Trigger fetch for the new page
  };

  const handleRowsPerPageChange = (event) => {
    const newPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newPerPage);
    setPage(0); // Reset to the first page
    updateQueryParams({ perPage: newPerPage, page: 1 });
  };


  return (
    <>
      <div
        className="py-1 px-4"
        style={{
          height: `calc(100vh - 100px)`,
        }}
      >
        <div className="flex flex-row mb-4 items-center justify-between">
          <p className="text-xl mb-0 font-extrabold">Logs ({response?.pageInfo.total})
          </p>
          <div className="flex flex-row">
            <FilterDropdown object={object} setObject={setObject} />
            <button onClick={() => handleFetch()} className="border focus:border-blue-600 flex items-center border-[#E0E0E0] ml-2 rounded py-1.5 px-3">Refresh Data</button>

          </div>
        </div>
        {!response?.data && !isLoading ? (
          <NoDataTable
            
            columns={columns}
            recordingKeyClassName={true}
            message={"Server Error, Please try again later."}
          />
        ) : response?.data?.length === 0 && !isLoading ? (
          <NoDataTable
            
            columns={columns}
            recordingKeyClassName={true}
            message={"No logs available to show"}
          />
        ) : (
          <CustomTable >
            <TableHeader columns={columns} />
            <MainTableBody isLoading={isLoading}>
              {response?.data?.length === 0
                ? [1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                  <LoadingTableSkeleton key={i} index={i} />
                ))
                : response?.data?.map((row, i) => (
                  <LogsTableRow key={i} row={row} refetch={refetch} />
                ))}
            </MainTableBody>

            {response?.pageInfo && (
              <TablePagination
                className="sticky bottom-0 bg-white"
                rowsPerPageOptions={[20]}
                count={response?.pageInfo.total}
                rowsPerPage={rowsPerPage}
                page={page}
                onRowsPerPageChange={handleRowsPerPageChange}
                onPageChange={handleChangePage}
              />
            )}
          </CustomTable>
        )}
      </div>
    </>
  );
}
